// extracted by mini-css-extract-plugin
export default {"guiding":"TgC3WbhN4Xsf37ArtVGS","icon1":"Ae3q9LAOsTe0KgUHcW39","icon2":"soB6BP1aJAlXkidhuwMr","common_bganimation":"vHGmLzqOJxN6H1BdMz50"};